import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';

export default function CarouselScheme({ onSchemeClick }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const [showArrows, setShowArrows] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const navigate = useNavigate();

    const minSwipeDistance = 50;
    const autoSlideInterval = 3000;

    // items array ko ek hi baar define karo
    const items = [
        {
            imageName: "22.webp",
            alt: "scheme1",
            schemeId: "30-day-daily-savings",
            link: "/schemes-v2?scheme=30-day-daily-savings"
        },
        {
            imageName: "23.webp",
            alt: "scheme2",
            schemeId: "10-month-accumulation",
            link: "/schemes-v2?scheme=10-month-accumulation"
        },
        {
            imageName: "24.webp",
            alt: "scheme3",
            schemeId: "11-month-direct-purchase",
            link: "/schemes-v2?scheme=11-month-direct-purchase"
        }
    ];

    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth < 768); // md breakpoint
        };
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    useEffect(() => {
        if (isPaused) return;
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === items.length - 1 ? 0 : prevIndex + 1
            );
        }, autoSlideInterval);
        return () => clearInterval(interval);
    }, [isPaused, items.length]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === items.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? items.length - 1 : prevIndex - 1
        );
    };

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
        setIsPaused(true);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            nextSlide();
        }
        if (isRightSwipe) {
            prevSlide();
        }
        setTimeout(() => setIsPaused(false), 1000);
    };

    const handleSchemeClick = () => {
        const currentScheme = items[currentIndex];
        const token = localStorage.getItem("token");

        if (token) {
            navigate(`/my-account/my-schemes?scheme=${currentScheme.schemeId}`);
        } else {
            navigate(`/schemes-v2?scheme=${currentScheme.schemeId}`);
        }

        if (onSchemeClick) {
            onSchemeClick(currentScheme.schemeId);
        }
    };

    const handleMouseEnter = () => {
        setShowArrows(true);
        setIsPaused(true);
    };

    const handleMouseLeave = () => {
        setShowArrows(false);
        setIsPaused(false);
    };

    return (
        <div style={{ position: 'relative', margin: "auto" }}>
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    touchAction: 'pan-y pinch-zoom'
                }}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Item item={items[currentIndex]} onSchemeClick={handleSchemeClick} />

                {!isMobile && (
                    <IconButton
                        sx={{
                            position: "absolute",
                            left: showArrows ? "10px" : "-50px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "white",
                            zIndex: 2,
                            backdropFilter: "blur(8px)",
                            transition: "left 0.3s ease",
                            "&:hover": {
                                background: "rgba(255, 255, 255, 0.2)",
                                backdropFilter: "blur(12px)",
                            }
                        }}
                        onClick={prevSlide}
                    >
                        <ChevronLeft />
                    </IconButton>
                )}

                {!isMobile && (
                    <IconButton
                        sx={{
                            position: "absolute",
                            right: showArrows ? "10px" : "-50px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "white",
                            zIndex: 2,
                            backdropFilter: "blur(8px)",
                            transition: "right 0.3s ease",
                            "&:hover": {
                                background: "rgba(255, 255, 255, 0.2)",
                                backdropFilter: "blur(12px)",
                            }
                        }}
                        onClick={nextSlide}
                    >
                        <ChevronRight />
                    </IconButton>
                )}

                <div style={{
                    position: "absolute",
                    bottom: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: "8px",
                    zIndex: 2
                }}>
                    {items.map((_, index) => (
                        <div
                            key={index}
                            style={{
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                backgroundColor: index === currentIndex ? "#a36e29" : "rgba(255,255,255,0.5)",
                                cursor: "pointer"
                            }}
                            onClick={() => setCurrentIndex(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

function Item(props) {
    return (
        <img
            src={process.env.PUBLIC_URL + `/assets/${props.item.imageName}`}
            alt={props.item.alt}
            style={{
                width: "100%",
                height: "100%",
                borderRadius: "10px",
                cursor: "pointer"
            }}
            onClick={props.onSchemeClick}
        />
    )
}